import { useContext, useEffect } from 'react'
import { fetchTourDeals } from 'actions/tour/TourV2Actions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import GeoContext from 'contexts/geoContext'

type ReturnType = [
  Record<string, App.Tours.TourDeal>,
  boolean
]

export function useTourDeals(): ReturnType {
  const dispatch = useAppDispatch()

  const deals = useAppSelector((state) => state.tour.tourDeals)
  const fetchingDeals = useAppSelector((state) => state.tour.fetchingTourDeals)
  const { currentRegionCode } = useContext(GeoContext)

  useEffect(() => {
    dispatch(fetchTourDeals(currentRegionCode.toUpperCase()))
  }, [dispatch, currentRegionCode])

  return [
    deals,
    fetchingDeals,
  ]
}
